import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type DistributorState = {
  distributorId: string | null;
  distributorName: string | null;

  setDistributorId: (id: string | null) => void;
  setDistributorName: (name: string | null) => void;
};

export const useDistributorStore = create<DistributorState>()(
  persist(
    (set) => ({
      distributorId: null,
      distributorName: null,

      setDistributorId: (id) => set({ distributorId: id }),
      setDistributorName: (name) => set({ distributorName: name }),
    }),
    {
      name: "distributor-storage", // key in localStorage
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({
        distributorId: s.distributorId,
        distributorName: s.distributorName,
      }),
    }
  )
);
